
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M6.83 3.99998H19C20.1 3.99998 21 4.89998 21 5.99998V18C21 18.05 20.99 18.1 20.98 18.16L17.6 14.78C17.84 14.59 18 14.32 18 14V13.5C18 13.22 17.78 13 17.5 13H17C16.72 13 16.5 13.22 16.5 13.5H16.33L14.5 11.67V10.5H16.5C16.5 10.78 16.72 11 17 11H17.5C17.78 11 18 10.78 18 10.5V9.99998C18 9.44998 17.55 8.99998 17 8.99998H14C13.45 8.99998 13 9.44998 13 9.99998V10.17L6.83 3.99998ZM20.49 21.9C20.1 22.29 19.47 22.29 19.08 21.9L17.18 20H5C3.89 20 3 19.1 3 18V5.99998C3 5.94998 3.02 5.89998 3.02 5.84998L2.1 4.92998C1.71 4.53998 1.71 3.90998 2.1 3.51998C2.49 3.12998 3.12 3.12998 3.51 3.51998L20.48 20.49C20.88 20.88 20.88 21.51 20.49 21.9ZM11 13.83L10.17 13H10C9.72 13 9.5 13.22 9.5 13.5H7.5V10.5H7.67L6.4 9.21998C6.16 9.40998 6 9.67998 6 9.99998V14C6 14.55 6.45 15 7 15H10C10.55 15 11 14.55 11 14V13.83Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-closed-caption-disabled`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconClosedCaptionDisabled

    ```js
    <b-new-b-icon-closed-caption-disabled />
    ```
</docs>


